/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface NotificationTemplatesService {
  /**
   * @summary Get All
   * @description Get all notification templates for the current office, including system templates.
   */
  getAllNotificationTemplatesGet: {
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetAllNotificationTemplatesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllNotificationTemplatesGetSchema,
        options: {
          parameters: GetAllNotificationTemplatesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetError>>
    ): Promise<RequestFnResponse<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetError>>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    getQueryKey(
      parameters: DeepReadonly<GetAllNotificationTemplatesGetParameters> | void
    ): ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllNotificationTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllNotificationTemplatesGetData,
          GetAllNotificationTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllNotificationTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllNotificationTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllNotificationTemplatesGetData,
          GetAllNotificationTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllNotificationTemplatesGetError>>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllNotificationTemplatesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllNotificationTemplatesGetParameters,
      TQueryFnData = GetAllNotificationTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllNotificationTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllNotificationTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllNotificationTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllNotificationTemplatesGetParameters,
      TQueryFnData = GetAllNotificationTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllNotificationTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllNotificationTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllNotificationTemplatesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllNotificationTemplatesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllNotificationTemplatesGetTotal = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAllNotificationTemplatesGetByParametersTotal = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             skip: skip
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllNotificationTemplatesGetResults = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllNotificationTemplatesGetCombinedResults = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTemplatesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllNotificationTemplatesGetSchema,
          GetAllNotificationTemplatesGetParameters,
          GetAllNotificationTemplatesGetData,
          GetAllNotificationTemplatesGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useSuspenseQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAllNotificationTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllNotificationTemplatesGetData,
          GetAllNotificationTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllNotificationTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllNotificationTemplatesGetParameters,
      TData = GetAllNotificationTemplatesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllNotificationTemplatesGetData,
          GetAllNotificationTemplatesGetError,
          OperationInfiniteData<TData, GetAllNotificationTemplatesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllNotificationTemplatesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllNotificationTemplatesGetParameters>,
      OperationError<GetAllNotificationTemplatesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllNotificationTemplatesGetData = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllNotificationTemplatesGetCombinedData = qraft.notificationTemplatesService.getAllNotificationTemplatesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllNotificationTemplatesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllNotificationTemplatesGetSchema,
          GetAllNotificationTemplatesGetParameters,
          GetAllNotificationTemplatesGetData,
          GetAllNotificationTemplatesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllNotificationTemplatesGetSchema,
        GetAllNotificationTemplatesGetData,
        GetAllNotificationTemplatesGetParameters,
        GetAllNotificationTemplatesGetError
      > | void
    ): Promise<GetAllNotificationTemplatesGetData>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllNotificationTemplatesGetSchema,
        GetAllNotificationTemplatesGetData,
        GetAllNotificationTemplatesGetParameters,
        GetAllNotificationTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllNotificationTemplatesGetSchema,
        GetAllNotificationTemplatesGetData,
        GetAllNotificationTemplatesGetParameters,
        GetAllNotificationTemplatesGetError
      > | void
    ): Promise<GetAllNotificationTemplatesGetData>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    fetchInfiniteQuery<TPageParam extends GetAllNotificationTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllNotificationTemplatesGetSchema,
        GetAllNotificationTemplatesGetData,
        GetAllNotificationTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllNotificationTemplatesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters>>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    prefetchInfiniteQuery<TPageParam extends GetAllNotificationTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllNotificationTemplatesGetSchema,
        GetAllNotificationTemplatesGetData,
        GetAllNotificationTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllNotificationTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    ensureInfiniteQueryData<TPageParam extends GetAllNotificationTemplatesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllNotificationTemplatesGetSchema,
        GetAllNotificationTemplatesGetData,
        GetAllNotificationTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllNotificationTemplatesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters>>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void)
    ): GetAllNotificationTemplatesGetData | undefined;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void)
    ): OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllNotificationTemplatesGetSchema,
              GetAllNotificationTemplatesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters>
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllNotificationTemplatesGetSchema,
              GetAllNotificationTemplatesGetParameters
            >,
            data: GetAllNotificationTemplatesGetData | undefined,
          ]
        >;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | void)
    ): QueryState<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetError> | undefined;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllNotificationTemplatesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters>,
          GetAllNotificationTemplatesGetError
        >
      | undefined;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllNotificationTemplatesGetSchema, GetAllNotificationTemplatesGetParameters>,
      updater: Updater<
        NoInfer<GetAllNotificationTemplatesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllNotificationTemplatesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllNotificationTemplatesGetData | undefined;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllNotificationTemplatesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetParameters
          >,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllNotificationTemplatesGetData, GetAllNotificationTemplatesGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >,
      updater: Updater<
        NoInfer<GetAllNotificationTemplatesGetData> | undefined,
        NoInfer<GetAllNotificationTemplatesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllNotificationTemplatesGetData | undefined>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllNotificationTemplatesGetSchema,
        GetAllNotificationTemplatesGetData,
        TInfinite,
        GetAllNotificationTemplatesGetParameters,
        GetAllNotificationTemplatesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
    ): void;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Get all notification templates for the current office, including system templates.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllNotificationTemplatesGetSchema,
            GetAllNotificationTemplatesGetData,
            TInfinite,
            GetAllNotificationTemplatesGetParameters,
            GetAllNotificationTemplatesGetError
          >
    ): number;
    schema: GetAllNotificationTemplatesGetSchema;
    types: {
      parameters: GetAllNotificationTemplatesGetParameters;
      data: GetAllNotificationTemplatesGetData;
      error: GetAllNotificationTemplatesGetError;
    };
  };
  /** @summary Create */
  createNotificationTemplatesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateNotificationTemplatesPostBody,
        CreateNotificationTemplatesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateNotificationTemplatesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateNotificationTemplatesPostBody,
          CreateNotificationTemplatesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateNotificationTemplatesPostData, CreateNotificationTemplatesPostError>>
    ): Promise<RequestFnResponse<CreateNotificationTemplatesPostData, CreateNotificationTemplatesPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateNotificationTemplatesPostParameters> | void
    ): ServiceOperationMutationKey<CreateNotificationTemplatesPostSchema, CreateNotificationTemplatesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.createNotificationTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.createNotificationTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateNotificationTemplatesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateNotificationTemplatesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateNotificationTemplatesPostSchema,
        CreateNotificationTemplatesPostData,
        CreateNotificationTemplatesPostParameters,
        TVariables,
        OperationError<CreateNotificationTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateNotificationTemplatesPostData,
      OperationError<CreateNotificationTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.createNotificationTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.createNotificationTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateNotificationTemplatesPostBody,
        CreateNotificationTemplatesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateNotificationTemplatesPostSchema,
        CreateNotificationTemplatesPostData,
        CreateNotificationTemplatesPostParameters,
        TVariables,
        OperationError<CreateNotificationTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateNotificationTemplatesPostData,
      OperationError<CreateNotificationTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createNotificationTemplatesPostTotal = qraft.notificationTemplatesService.createNotificationTemplatesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createNotificationTemplatesPostTotal = qraft.notificationTemplatesService.createNotificationTemplatesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateNotificationTemplatesPostBody,
            CreateNotificationTemplatesPostData,
            CreateNotificationTemplatesPostParameters,
            OperationError<CreateNotificationTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotificationTemplatesPostSchema,
            CreateNotificationTemplatesPostBody,
            CreateNotificationTemplatesPostData,
            CreateNotificationTemplatesPostParameters,
            OperationError<CreateNotificationTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createNotificationTemplatesPostPendingMutationVariables = qraft.notificationTemplatesService.createNotificationTemplatesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createNotificationTemplatesPostMutationData = qraft.notificationTemplatesService.createNotificationTemplatesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateNotificationTemplatesPostData,
        OperationError<CreateNotificationTemplatesPostError>,
        MutationVariables<CreateNotificationTemplatesPostBody, CreateNotificationTemplatesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateNotificationTemplatesPostBody,
            CreateNotificationTemplatesPostData,
            CreateNotificationTemplatesPostParameters,
            OperationError<CreateNotificationTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotificationTemplatesPostSchema,
            CreateNotificationTemplatesPostBody,
            CreateNotificationTemplatesPostData,
            CreateNotificationTemplatesPostParameters,
            OperationError<CreateNotificationTemplatesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateNotificationTemplatesPostData,
          OperationError<CreateNotificationTemplatesPostError>,
          MutationVariables<CreateNotificationTemplatesPostBody, CreateNotificationTemplatesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateNotificationTemplatesPostBody,
            CreateNotificationTemplatesPostData,
            CreateNotificationTemplatesPostParameters,
            OperationError<CreateNotificationTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotificationTemplatesPostSchema,
            CreateNotificationTemplatesPostBody,
            CreateNotificationTemplatesPostData,
            CreateNotificationTemplatesPostParameters,
            OperationError<CreateNotificationTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notificationTemplatesService.createNotificationTemplatesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notificationTemplatesService.createNotificationTemplatesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateNotificationTemplatesPostBody,
              CreateNotificationTemplatesPostData,
              CreateNotificationTemplatesPostParameters,
              OperationError<CreateNotificationTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateNotificationTemplatesPostSchema,
              CreateNotificationTemplatesPostBody,
              CreateNotificationTemplatesPostData,
              CreateNotificationTemplatesPostParameters,
              OperationError<CreateNotificationTemplatesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateNotificationTemplatesPostData,
            CreateNotificationTemplatesPostError,
            MutationVariables<CreateNotificationTemplatesPostBody, CreateNotificationTemplatesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateNotificationTemplatesPostBody,
              CreateNotificationTemplatesPostData,
              CreateNotificationTemplatesPostParameters,
              OperationError<CreateNotificationTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateNotificationTemplatesPostSchema,
              CreateNotificationTemplatesPostBody,
              CreateNotificationTemplatesPostData,
              CreateNotificationTemplatesPostParameters,
              OperationError<CreateNotificationTemplatesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateNotificationTemplatesPostData,
          CreateNotificationTemplatesPostError,
          MutationVariables<CreateNotificationTemplatesPostBody, CreateNotificationTemplatesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateNotificationTemplatesPostSchema;
    types: {
      parameters: CreateNotificationTemplatesPostParameters;
      data: CreateNotificationTemplatesPostData;
      error: CreateNotificationTemplatesPostError;
      body: CreateNotificationTemplatesPostBody;
    };
  };
  /** @summary Update */
  updateNotificationTemplatesTemplateIdPut: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateNotificationTemplatesTemplateIdPutBody,
        UpdateNotificationTemplatesTemplateIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateNotificationTemplatesTemplateIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateNotificationTemplatesTemplateIdPutBody,
          UpdateNotificationTemplatesTemplateIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<UpdateNotificationTemplatesTemplateIdPutData, UpdateNotificationTemplatesTemplateIdPutError>
      >
    ): Promise<
      RequestFnResponse<UpdateNotificationTemplatesTemplateIdPutData, UpdateNotificationTemplatesTemplateIdPutError>
    >;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateNotificationTemplatesTemplateIdPutParameters> | void
    ): ServiceOperationMutationKey<
      UpdateNotificationTemplatesTemplateIdPutSchema,
      UpdateNotificationTemplatesTemplateIdPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateNotificationTemplatesTemplateIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateNotificationTemplatesTemplateIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateNotificationTemplatesTemplateIdPutSchema,
        UpdateNotificationTemplatesTemplateIdPutData,
        UpdateNotificationTemplatesTemplateIdPutParameters,
        TVariables,
        OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateNotificationTemplatesTemplateIdPutData,
      OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateNotificationTemplatesTemplateIdPutBody,
        UpdateNotificationTemplatesTemplateIdPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateNotificationTemplatesTemplateIdPutSchema,
        UpdateNotificationTemplatesTemplateIdPutData,
        UpdateNotificationTemplatesTemplateIdPutParameters,
        TVariables,
        OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateNotificationTemplatesTemplateIdPutData,
      OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateNotificationTemplatesTemplateIdPutTotal = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateNotificationTemplatesTemplateIdPutTotal = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutData,
            UpdateNotificationTemplatesTemplateIdPutParameters,
            OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateNotificationTemplatesTemplateIdPutSchema,
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutData,
            UpdateNotificationTemplatesTemplateIdPutParameters,
            OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateNotificationTemplatesTemplateIdPutPendingMutationVariables = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateNotificationTemplatesTemplateIdPutMutationData = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateNotificationTemplatesTemplateIdPutData,
        OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
        MutationVariables<
          UpdateNotificationTemplatesTemplateIdPutBody,
          UpdateNotificationTemplatesTemplateIdPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutData,
            UpdateNotificationTemplatesTemplateIdPutParameters,
            OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateNotificationTemplatesTemplateIdPutSchema,
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutData,
            UpdateNotificationTemplatesTemplateIdPutParameters,
            OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateNotificationTemplatesTemplateIdPutData,
          OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
          MutationVariables<
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutData,
            UpdateNotificationTemplatesTemplateIdPutParameters,
            OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateNotificationTemplatesTemplateIdPutSchema,
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutData,
            UpdateNotificationTemplatesTemplateIdPutParameters,
            OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notificationTemplatesService.updateNotificationTemplatesTemplateIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateNotificationTemplatesTemplateIdPutBody,
              UpdateNotificationTemplatesTemplateIdPutData,
              UpdateNotificationTemplatesTemplateIdPutParameters,
              OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateNotificationTemplatesTemplateIdPutSchema,
              UpdateNotificationTemplatesTemplateIdPutBody,
              UpdateNotificationTemplatesTemplateIdPutData,
              UpdateNotificationTemplatesTemplateIdPutParameters,
              OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateNotificationTemplatesTemplateIdPutData,
            UpdateNotificationTemplatesTemplateIdPutError,
            MutationVariables<
              UpdateNotificationTemplatesTemplateIdPutBody,
              UpdateNotificationTemplatesTemplateIdPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateNotificationTemplatesTemplateIdPutBody,
              UpdateNotificationTemplatesTemplateIdPutData,
              UpdateNotificationTemplatesTemplateIdPutParameters,
              OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateNotificationTemplatesTemplateIdPutSchema,
              UpdateNotificationTemplatesTemplateIdPutBody,
              UpdateNotificationTemplatesTemplateIdPutData,
              UpdateNotificationTemplatesTemplateIdPutParameters,
              OperationError<UpdateNotificationTemplatesTemplateIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateNotificationTemplatesTemplateIdPutData,
          UpdateNotificationTemplatesTemplateIdPutError,
          MutationVariables<
            UpdateNotificationTemplatesTemplateIdPutBody,
            UpdateNotificationTemplatesTemplateIdPutParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateNotificationTemplatesTemplateIdPutSchema;
    types: {
      parameters: UpdateNotificationTemplatesTemplateIdPutParameters;
      data: UpdateNotificationTemplatesTemplateIdPutData;
      error: UpdateNotificationTemplatesTemplateIdPutError;
      body: UpdateNotificationTemplatesTemplateIdPutBody;
    };
  };
  /**
   * @summary Get By Id
   * @description Get notification template by ID.
   */
  getByIdNotificationTemplatesTemplateIdGet: {
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetByIdNotificationTemplatesTemplateIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetByIdNotificationTemplatesTemplateIdGetSchema,
        options: {
          parameters: GetByIdNotificationTemplatesTemplateIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetByIdNotificationTemplatesTemplateIdGetData, GetByIdNotificationTemplatesTemplateIdGetError>
      >
    ): Promise<
      RequestFnResponse<GetByIdNotificationTemplatesTemplateIdGetData, GetByIdNotificationTemplatesTemplateIdGetError>
    >;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
    ): ServiceOperationQueryKey<
      GetByIdNotificationTemplatesTemplateIdGetSchema,
      GetByIdNotificationTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdNotificationTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetByIdNotificationTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdNotificationTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetByIdNotificationTemplatesTemplateIdGetError>>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetByIdNotificationTemplatesTemplateIdGetSchema,
      GetByIdNotificationTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdNotificationTemplatesTemplateIdGetParameters,
      TQueryFnData = GetByIdNotificationTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdNotificationTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdNotificationTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetByIdNotificationTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdNotificationTemplatesTemplateIdGetParameters,
      TQueryFnData = GetByIdNotificationTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdNotificationTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdNotificationTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdNotificationTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetByIdNotificationTemplatesTemplateIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getByIdNotificationTemplatesTemplateIdGetTotal = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getByIdNotificationTemplatesTemplateIdGetByParametersTotal = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getByIdNotificationTemplatesTemplateIdGetResults = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getByIdNotificationTemplatesTemplateIdGetCombinedResults = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTemplatesTemplateIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetByIdNotificationTemplatesTemplateIdGetSchema,
          GetByIdNotificationTemplatesTemplateIdGetParameters,
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetByIdNotificationTemplatesTemplateIdGetData, GetByIdNotificationTemplatesTemplateIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetByIdNotificationTemplatesTemplateIdGetData, GetByIdNotificationTemplatesTemplateIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useSuspenseQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetByIdNotificationTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetByIdNotificationTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetByIdNotificationTemplatesTemplateIdGetParameters,
      TData = GetByIdNotificationTemplatesTemplateIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetError,
          OperationInfiniteData<TData, GetByIdNotificationTemplatesTemplateIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdNotificationTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetByIdNotificationTemplatesTemplateIdGetParameters>,
      OperationError<GetByIdNotificationTemplatesTemplateIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Get notification template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getByIdNotificationTemplatesTemplateIdGetData = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getByIdNotificationTemplatesTemplateIdGetCombinedData = qraft.notificationTemplatesService.getByIdNotificationTemplatesTemplateIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getByIdNotificationTemplatesTemplateIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetByIdNotificationTemplatesTemplateIdGetSchema,
          GetByIdNotificationTemplatesTemplateIdGetParameters,
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetByIdNotificationTemplatesTemplateIdGetData,
              GetByIdNotificationTemplatesTemplateIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdNotificationTemplatesTemplateIdGetSchema,
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters,
        GetByIdNotificationTemplatesTemplateIdGetError
      >
    ): Promise<GetByIdNotificationTemplatesTemplateIdGetData>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdNotificationTemplatesTemplateIdGetSchema,
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters,
        GetByIdNotificationTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetByIdNotificationTemplatesTemplateIdGetSchema,
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters,
        GetByIdNotificationTemplatesTemplateIdGetError
      >
    ): Promise<GetByIdNotificationTemplatesTemplateIdGetData>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetByIdNotificationTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdNotificationTemplatesTemplateIdGetSchema,
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdNotificationTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters
      >
    >;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetByIdNotificationTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdNotificationTemplatesTemplateIdGetSchema,
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdNotificationTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetByIdNotificationTemplatesTemplateIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetByIdNotificationTemplatesTemplateIdGetSchema,
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdNotificationTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetByIdNotificationTemplatesTemplateIdGetData,
        GetByIdNotificationTemplatesTemplateIdGetParameters
      >
    >;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
    ): GetByIdNotificationTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
    ):
      | OperationInfiniteData<
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetByIdNotificationTemplatesTemplateIdGetSchema,
              GetByIdNotificationTemplatesTemplateIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetByIdNotificationTemplatesTemplateIdGetData,
                    GetByIdNotificationTemplatesTemplateIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetByIdNotificationTemplatesTemplateIdGetSchema,
              GetByIdNotificationTemplatesTemplateIdGetParameters
            >,
            data: GetByIdNotificationTemplatesTemplateIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
    ):
      | QueryState<GetByIdNotificationTemplatesTemplateIdGetData, GetByIdNotificationTemplatesTemplateIdGetError>
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetByIdNotificationTemplatesTemplateIdGetData,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >,
          GetByIdNotificationTemplatesTemplateIdGetError
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
        | ServiceOperationQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetByIdNotificationTemplatesTemplateIdGetData> | undefined,
        NoInfer<DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetByIdNotificationTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetByIdNotificationTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetByIdNotificationTemplatesTemplateIdGetData,
              GetByIdNotificationTemplatesTemplateIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetByIdNotificationTemplatesTemplateIdGetData,
                GetByIdNotificationTemplatesTemplateIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetByIdNotificationTemplatesTemplateIdGetData,
          GetByIdNotificationTemplatesTemplateIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >,
      updater: Updater<
        NoInfer<GetByIdNotificationTemplatesTemplateIdGetData> | undefined,
        NoInfer<GetByIdNotificationTemplatesTemplateIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetByIdNotificationTemplatesTemplateIdGetData | undefined>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetByIdNotificationTemplatesTemplateIdGetSchema,
        GetByIdNotificationTemplatesTemplateIdGetData,
        TInfinite,
        GetByIdNotificationTemplatesTemplateIdGetParameters,
        GetByIdNotificationTemplatesTemplateIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
    ): void;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Get notification template by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdNotificationTemplatesTemplateIdGetSchema,
            GetByIdNotificationTemplatesTemplateIdGetData,
            TInfinite,
            GetByIdNotificationTemplatesTemplateIdGetParameters,
            GetByIdNotificationTemplatesTemplateIdGetError
          >
    ): number;
    schema: GetByIdNotificationTemplatesTemplateIdGetSchema;
    types: {
      parameters: GetByIdNotificationTemplatesTemplateIdGetParameters;
      data: GetByIdNotificationTemplatesTemplateIdGetData;
      error: GetByIdNotificationTemplatesTemplateIdGetError;
    };
  };
  /** @summary Delete */
  deleteNotificationTemplatesTemplateIdDelete: {
    /** @summary Delete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteNotificationTemplatesTemplateIdDeleteBody,
        DeleteNotificationTemplatesTemplateIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteNotificationTemplatesTemplateIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteNotificationTemplatesTemplateIdDeleteBody,
          DeleteNotificationTemplatesTemplateIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteNotificationTemplatesTemplateIdDeleteData,
          DeleteNotificationTemplatesTemplateIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteNotificationTemplatesTemplateIdDeleteData,
        DeleteNotificationTemplatesTemplateIdDeleteError
      >
    >;
    /** @summary Delete */
    getMutationKey(
      parameters: DeepReadonly<DeleteNotificationTemplatesTemplateIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteNotificationTemplatesTemplateIdDeleteSchema,
      DeleteNotificationTemplatesTemplateIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteNotificationTemplatesTemplateIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteNotificationTemplatesTemplateIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteNotificationTemplatesTemplateIdDeleteSchema,
        DeleteNotificationTemplatesTemplateIdDeleteData,
        DeleteNotificationTemplatesTemplateIdDeleteParameters,
        TVariables,
        OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteNotificationTemplatesTemplateIdDeleteData,
      OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteNotificationTemplatesTemplateIdDeleteBody,
        DeleteNotificationTemplatesTemplateIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteNotificationTemplatesTemplateIdDeleteSchema,
        DeleteNotificationTemplatesTemplateIdDeleteData,
        DeleteNotificationTemplatesTemplateIdDeleteParameters,
        TVariables,
        OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteNotificationTemplatesTemplateIdDeleteData,
      OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteNotificationTemplatesTemplateIdDeleteTotal = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteNotificationTemplatesTemplateIdDeleteTotal = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteData,
            DeleteNotificationTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteNotificationTemplatesTemplateIdDeleteSchema,
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteData,
            DeleteNotificationTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteNotificationTemplatesTemplateIdDeletePendingMutationVariables = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteNotificationTemplatesTemplateIdDeleteMutationData = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteNotificationTemplatesTemplateIdDeleteData,
        OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
        MutationVariables<
          DeleteNotificationTemplatesTemplateIdDeleteBody,
          DeleteNotificationTemplatesTemplateIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteData,
            DeleteNotificationTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteNotificationTemplatesTemplateIdDeleteSchema,
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteData,
            DeleteNotificationTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteNotificationTemplatesTemplateIdDeleteData,
          OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
          MutationVariables<
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Delete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteData,
            DeleteNotificationTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteNotificationTemplatesTemplateIdDeleteSchema,
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteData,
            DeleteNotificationTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notificationTemplatesService.deleteNotificationTemplatesTemplateIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteNotificationTemplatesTemplateIdDeleteBody,
              DeleteNotificationTemplatesTemplateIdDeleteData,
              DeleteNotificationTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteNotificationTemplatesTemplateIdDeleteSchema,
              DeleteNotificationTemplatesTemplateIdDeleteBody,
              DeleteNotificationTemplatesTemplateIdDeleteData,
              DeleteNotificationTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteNotificationTemplatesTemplateIdDeleteData,
            DeleteNotificationTemplatesTemplateIdDeleteError,
            MutationVariables<
              DeleteNotificationTemplatesTemplateIdDeleteBody,
              DeleteNotificationTemplatesTemplateIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteNotificationTemplatesTemplateIdDeleteBody,
              DeleteNotificationTemplatesTemplateIdDeleteData,
              DeleteNotificationTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteNotificationTemplatesTemplateIdDeleteSchema,
              DeleteNotificationTemplatesTemplateIdDeleteBody,
              DeleteNotificationTemplatesTemplateIdDeleteData,
              DeleteNotificationTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteNotificationTemplatesTemplateIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteNotificationTemplatesTemplateIdDeleteData,
          DeleteNotificationTemplatesTemplateIdDeleteError,
          MutationVariables<
            DeleteNotificationTemplatesTemplateIdDeleteBody,
            DeleteNotificationTemplatesTemplateIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteNotificationTemplatesTemplateIdDeleteSchema;
    types: {
      parameters: DeleteNotificationTemplatesTemplateIdDeleteParameters;
      data: DeleteNotificationTemplatesTemplateIdDeleteData;
      error: DeleteNotificationTemplatesTemplateIdDeleteError;
      body: DeleteNotificationTemplatesTemplateIdDeleteBody;
    };
  };
  /**
   * @summary Template Variables
   * @description Get a simplified list of available template variables for notification templates.
   */
  templateVariablesNotificationTemplatesTemplateVariablesGet: {
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TMeta,
            TSignal
          > | void),
      client?: (
        schema: TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        options: {
          parameters: TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      >
    >;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    getQueryKey(
      parameters: DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void
    ): ServiceOperationQueryKey<
      TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
      TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useQuery()
     * ```
     */
    useQuery<TData = TemplateVariablesNotificationTemplatesTemplateVariablesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError,
          TData,
          ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<TemplateVariablesNotificationTemplatesTemplateVariablesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useQuery()
     * ```
     */
    useQuery<TData = TemplateVariablesNotificationTemplatesTemplateVariablesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError,
          TData,
          ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<TemplateVariablesNotificationTemplatesTemplateVariablesGetError>>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
      TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
      TQueryFnData = TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
      TData = OperationInfiniteData<TQueryFnData, TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<TemplateVariablesNotificationTemplatesTemplateVariablesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
      TQueryFnData = TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
      TData = OperationInfiniteData<TQueryFnData, TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<TemplateVariablesNotificationTemplatesTemplateVariablesGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const templateVariablesNotificationTemplatesTemplateVariablesGetTotal = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const templateVariablesNotificationTemplatesTemplateVariablesGetResults = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * templateVariablesNotificationTemplatesTemplateVariablesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const templateVariablesNotificationTemplatesTemplateVariablesGetCombinedResults = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * templateVariablesNotificationTemplatesTemplateVariablesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = TemplateVariablesNotificationTemplatesTemplateVariablesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError,
          TData,
          ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<TemplateVariablesNotificationTemplatesTemplateVariablesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
      TData = TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError,
          OperationInfiniteData<TData, TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>,
      OperationError<TemplateVariablesNotificationTemplatesTemplateVariablesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const templateVariablesNotificationTemplatesTemplateVariablesGetData = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * templateVariablesNotificationTemplatesTemplateVariablesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const templateVariablesNotificationTemplatesTemplateVariablesGetCombinedData = qraft.notificationTemplatesService.templateVariablesNotificationTemplatesTemplateVariablesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * templateVariablesNotificationTemplatesTemplateVariablesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
              TemplateVariablesNotificationTemplatesTemplateVariablesGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      > | void
    ): Promise<TemplateVariablesNotificationTemplatesTemplateVariablesGetData>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      > | void
    ): Promise<TemplateVariablesNotificationTemplatesTemplateVariablesGetData>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    fetchInfiniteQuery<TPageParam extends TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
        DeepReadonly<TPageParam>,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
      >
    >;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    prefetchInfiniteQuery<TPageParam extends TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
        DeepReadonly<TPageParam>,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    ensureInfiniteQueryData<TPageParam extends TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
        DeepReadonly<TPageParam>,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
      >
    >;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void)
    ): TemplateVariablesNotificationTemplatesTemplateVariablesGetData | undefined;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void)
    ):
      | OperationInfiniteData<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
        >
      | undefined;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
              TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
                    TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
              TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
            >,
            data: TemplateVariablesNotificationTemplatesTemplateVariablesGetData | undefined,
          ]
        >;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | void)
    ):
      | QueryState<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError
        >
      | undefined;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetError
        >
      | undefined;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | undefined)
        | ServiceOperationQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >,
      updater: Updater<
        NoInfer<TemplateVariablesNotificationTemplatesTemplateVariablesGetData> | undefined,
        NoInfer<DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): TemplateVariablesNotificationTemplatesTemplateVariablesGetData | undefined;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
              TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
                TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
          TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters
        >
      | undefined;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >,
      updater: Updater<
        NoInfer<TemplateVariablesNotificationTemplatesTemplateVariablesGetData> | undefined,
        NoInfer<TemplateVariablesNotificationTemplatesTemplateVariablesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<TemplateVariablesNotificationTemplatesTemplateVariablesGetData | undefined>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
        TInfinite,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
        TemplateVariablesNotificationTemplatesTemplateVariablesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
    ): void;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Template Variables
     * @description Get a simplified list of available template variables for notification templates.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
        | QueryFiltersByQueryKey<
            TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetData,
            TInfinite,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters,
            TemplateVariablesNotificationTemplatesTemplateVariablesGetError
          >
    ): number;
    schema: TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema;
    types: {
      parameters: TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters;
      data: TemplateVariablesNotificationTemplatesTemplateVariablesGetData;
      error: TemplateVariablesNotificationTemplatesTemplateVariablesGetError;
    };
  };
}
/**
 * @summary Get All
 * @description Get all notification templates for the current office, including system templates.
 */
export const getAllNotificationTemplatesGet = {
  schema: {
    method: 'get',
    url: '/notification_templates',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllNotificationTemplatesGetSchema;
  [QraftServiceOperationsToken]: NotificationTemplatesService['getAllNotificationTemplatesGet'];
};
/** @summary Create */
export const createNotificationTemplatesPost = {
  schema: {
    method: 'post',
    url: '/notification_templates',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateNotificationTemplatesPostSchema;
  [QraftServiceOperationsToken]: NotificationTemplatesService['createNotificationTemplatesPost'];
};
/** @summary Update */
export const updateNotificationTemplatesTemplateIdPut = {
  schema: {
    method: 'put',
    url: '/notification_templates/{template_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateNotificationTemplatesTemplateIdPutSchema;
  [QraftServiceOperationsToken]: NotificationTemplatesService['updateNotificationTemplatesTemplateIdPut'];
};
/**
 * @summary Get By Id
 * @description Get notification template by ID.
 */
export const getByIdNotificationTemplatesTemplateIdGet = {
  schema: {
    method: 'get',
    url: '/notification_templates/{template_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetByIdNotificationTemplatesTemplateIdGetSchema;
  [QraftServiceOperationsToken]: NotificationTemplatesService['getByIdNotificationTemplatesTemplateIdGet'];
};
/** @summary Delete */
export const deleteNotificationTemplatesTemplateIdDelete = {
  schema: {
    method: 'delete',
    url: '/notification_templates/{template_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteNotificationTemplatesTemplateIdDeleteSchema;
  [QraftServiceOperationsToken]: NotificationTemplatesService['deleteNotificationTemplatesTemplateIdDelete'];
};
/**
 * @summary Template Variables
 * @description Get a simplified list of available template variables for notification templates.
 */
export const templateVariablesNotificationTemplatesTemplateVariablesGet = {
  schema: {
    method: 'get',
    url: '/notification_templates/template_variables',
  },
} as {
  schema: TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema;
  [QraftServiceOperationsToken]: NotificationTemplatesService['templateVariablesNotificationTemplatesTemplateVariablesGet'];
};
export const notificationTemplatesService = {
  getAllNotificationTemplatesGet,
  createNotificationTemplatesPost,
  updateNotificationTemplatesTemplateIdPut,
  getByIdNotificationTemplatesTemplateIdGet,
  deleteNotificationTemplatesTemplateIdDelete,
  templateVariablesNotificationTemplatesTemplateVariablesGet,
} as const;
type GetAllNotificationTemplatesGetSchema = {
  method: 'get';
  url: '/notification_templates';
  security: ['HTTPBearer'];
};
type GetAllNotificationTemplatesGetParameters = paths['/notification_templates']['get']['parameters'];
type GetAllNotificationTemplatesGetData =
  paths['/notification_templates']['get']['responses']['200']['content']['application/json'];
type GetAllNotificationTemplatesGetError =
  paths['/notification_templates']['get']['responses']['422']['content']['application/json'];
type CreateNotificationTemplatesPostSchema = {
  method: 'post';
  url: '/notification_templates';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateNotificationTemplatesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateNotificationTemplatesPostData =
  paths['/notification_templates']['post']['responses']['200']['content']['application/json'];
type CreateNotificationTemplatesPostError =
  paths['/notification_templates']['post']['responses']['422']['content']['application/json'];
type CreateNotificationTemplatesPostBody =
  paths['/notification_templates']['post']['requestBody']['content']['application/json'];
type UpdateNotificationTemplatesTemplateIdPutSchema = {
  method: 'put';
  url: '/notification_templates/{template_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateNotificationTemplatesTemplateIdPutParameters =
  paths['/notification_templates/{template_id}']['put']['parameters'];
type UpdateNotificationTemplatesTemplateIdPutData =
  paths['/notification_templates/{template_id}']['put']['responses']['200']['content']['application/json'];
type UpdateNotificationTemplatesTemplateIdPutError =
  paths['/notification_templates/{template_id}']['put']['responses']['422']['content']['application/json'];
type UpdateNotificationTemplatesTemplateIdPutBody =
  paths['/notification_templates/{template_id}']['put']['requestBody']['content']['application/json'];
type GetByIdNotificationTemplatesTemplateIdGetSchema = {
  method: 'get';
  url: '/notification_templates/{template_id}';
  security: ['HTTPBearer'];
};
type GetByIdNotificationTemplatesTemplateIdGetParameters =
  paths['/notification_templates/{template_id}']['get']['parameters'];
type GetByIdNotificationTemplatesTemplateIdGetData =
  paths['/notification_templates/{template_id}']['get']['responses']['200']['content']['application/json'];
type GetByIdNotificationTemplatesTemplateIdGetError =
  paths['/notification_templates/{template_id}']['get']['responses']['422']['content']['application/json'];
type DeleteNotificationTemplatesTemplateIdDeleteSchema = {
  method: 'delete';
  url: '/notification_templates/{template_id}';
  security: ['HTTPBearer'];
};
type DeleteNotificationTemplatesTemplateIdDeleteParameters =
  paths['/notification_templates/{template_id}']['delete']['parameters'];
type DeleteNotificationTemplatesTemplateIdDeleteData =
  paths['/notification_templates/{template_id}']['delete']['responses']['200']['content']['application/json'];
type DeleteNotificationTemplatesTemplateIdDeleteError =
  paths['/notification_templates/{template_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteNotificationTemplatesTemplateIdDeleteBody = undefined;
type TemplateVariablesNotificationTemplatesTemplateVariablesGetSchema = {
  method: 'get';
  url: '/notification_templates/template_variables';
};
type TemplateVariablesNotificationTemplatesTemplateVariablesGetParameters = undefined;
type TemplateVariablesNotificationTemplatesTemplateVariablesGetData =
  paths['/notification_templates/template_variables']['get']['responses']['200']['content']['application/json'];
type TemplateVariablesNotificationTemplatesTemplateVariablesGetError = unknown;
